/**
 * Safe clipboard utility that handles browser compatibility and errors gracefully
 */

export const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    // Check if the Clipboard API is available
    if (navigator?.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
    
    // Fallback for older browsers or insecure contexts
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    const success = document.execCommand('copy');
    document.body.removeChild(textArea);
    
    return success;
  } catch (err) {
    console.error('Failed to copy to clipboard:', err);
    return false;
  }
};

export const isClipboardSupported = (): boolean => {
  return !!(navigator?.clipboard?.writeText || document.execCommand);
};